import { lazy } from 'react'
import { RouteProps } from 'app/shared/types'

const WorkList = lazy(() => import('./work-list/WorkList'))
const FacilityAdminChangeList = lazy(
  () => import('./facility-admin-change-request/facility-admin-change-list')
)
const FacilityAdminChangeDetail = lazy(
  () => import('./facility-admin-change-request/facility-admin-change-detail')
)

const Home = lazy(() => import('./home'))
const CategoryInfoManagement = lazy(
  () => import('./home/CategoryInfoManagement')
)

const Reporting = lazy(() => import('./reporting'))
const SignIn = lazy(() => import('./signin'))
const SignOut = lazy(() => import('./signout'))
const SignUp = lazy(() => import('./signup'))
const Profile = lazy(() => import('./profile/my-profile'))
const ChangeUser = lazy(() => import('./change-user'))
const FacilityAdminChangeRequest = lazy(
  () => import('./facility-admin-change-request')
)
const SendLocation = lazy(() => import('./send-location'))

const CertificationReport = lazy(() => import('./certification-report'))

const CreateDictionary = lazy(() => import('./dictionary/create-dictionary'))

const UpdateDictionary = lazy(() => import('./dictionary/update-dictionary'))
const DictionaryList = lazy(() => import('./dictionary/dictionary-list'))
const LayoverSubCategoryList = lazy(
  () => import('./layover-subcategory/layover-subcategory-list')
)
const UpdateLayoverSubCategory = lazy(
  () => import('./layover-subcategory/update-layover-subcategory')
)
const CreateLayoverSubCategory = lazy(
  () => import('./layover-subcategory/create-layover-subcategory')
)
const LayoverFacilityTypeList = lazy(
  () => import('./layover-facility-type/layover-facility-type-list')
)
const UpdateLayoverFacilityType = lazy(
  () => import('./layover-facility-type/update-layover-facility-type')
)
const CreateLayoverFacilityType = lazy(
  () => import('./layover-facility-type/create-layover-facility-type')
)
const HotelList = lazy(() => import('./hotel/hotel-list'))
const UpdateHotel = lazy(() => import('./hotel/update-hotel'))
const UpdateHotelRevised = lazy(() => import('./hotel/update-hotel-revised'))
const UpdateHotelAdmin = lazy(() => import('./hotel/update-hotel-admin'))
const CreateHotel = lazy(() => import('./hotel/create-hotel'))
const CarbonParameter = lazy(() => import('./carbon-parameter'))
const CarbonParameterUpdate = lazy(
  () => import('./carbon-parameter/update-carbon-parameter')
)
const CarbonFacilityList = lazy(() => import('./carbon-facility-list'))
const CarbonHomePage = lazy(() => import('./carbon-home-page'))
const CarbonResult = lazy(() => import('./carbon-result-screen'))
const CarbonPerformanceReport = lazy(
  () => import('./carbon-performance-report')
)
const CarbonPerformanceReportV2 = lazy(
  () => import('./carbon-performance-report-v2')
)

const DashboardDetailUpdate = lazy(
  () => import('./dashboard-detail/update-dashboard-detail')
)
const Email = lazy(() => import('./forgot-password/email'))
const Password = lazy(() => import('./forgot-password/password'))
const VerifacitionEmail = lazy(
  () => import('./verificationEmail/VerificationEmail')
)
const OtherDocumentList = lazy(
  () => import('./other-document/other-document-list')
)
const UpdateOtherDocument = lazy(
  () => import('./other-document/update-other-document')
)
const CreateOtherDocument = lazy(
  () => import('./other-document/create-other-document')
)
const FacilityRevisionList = lazy(() => import('./facility-revision'))

const FacilityCertificateRevisionApplication = lazy(
  () => import('./facility-certificate-revision-application')
)
const FacilityRevisionAdminList = lazy(
  () => import('./facility-revision-admin')
)

const FacilityCertificateRevisionAdminList = lazy(
  () => import('./facility-certificate-revision-admin')
)
const CreateCertificateType = lazy(
  () => import('./certificate-type/create-certificate-type')
)
const UpdateCertificateType = lazy(
  () => import('./certificate-type/update-certificate-type')
)
const CertificateTypeList = lazy(
  () => import('./certificate-type/certificate-type-list')
)
const ApplicationUserList = lazy(
  () => import('./application-user/application-user-list')
)
const ApplicationUserDetail = lazy(
  () => import('./application-user/application-user-detail')
)
const CreateUser = lazy(() => import('./user/create-user'))
const UpdateUser = lazy(() => import('./user/update-user'))
const UserList = lazy(() => import('./user/user-list'))
const LogList = lazy(() => import('./log/log-list'))
const GstcList = lazy(() => import('./gstc/gstc-list'))
const GstcDictionaryList = lazy(() => import('./gstc-dictionary/gstc-list'))
const methodologyInformationList = lazy(
  () => import('./methodology-information/methodology-information')
)

const RolePermissionUpdate = lazy(
  () => import('./role-permission/update-role-permission')
)
const RolePermissionList = lazy(
  () => import('./role-permission/role-permission-list')
)
const MailManagementUpdate = lazy(
  () => import('./mail-management/update-mail-management')
)
const MailManagementList = lazy(
  () => import('./mail-management/mail-management-list')
)
const CreateAuditCompany = lazy(
  () => import('./audit-company/create-audit-company')
)
const UpdateAuditCompany = lazy(
  () => import('./audit-company/update-audit-company')
)
const AuditCompanyList = lazy(
  () => import('./audit-company/audit-company-list')
)
const CreateHotelCertificate = lazy(
  () => import('./hotel-certificate/create-hotel-certificate')
)
const UpdateHotelCertificate = lazy(
  () => import('./hotel-certificate/update-hotel-certificate')
)
const UpdateHotelCertificateAdmin = lazy(
  () => import('./hotel-certificate/update-hotel-certificate-admin')
)

const HotelCertificateList = lazy(
  () => import('./hotel-certificate/hotel-certificate-list')
)
const Dashboard = lazy(() => import('./dashboard'))
const CreateDashboard = lazy(() => import('./dashboardItem/create-dashboard'))
const UpdateDashboard = lazy(() => import('./dashboardItem/update-dashboard'))
const DashboardList = lazy(() => import('./dashboardItem/dashboard-list'))
const RequestApproval = lazy(() => import('./request-approval'))
const ApprovalAudit = lazy(() => import('./approval-audit'))
const TransferRequest = lazy(() => import('./transfer-request'))
const AuditList = lazy(() => import('./audit-list/audit-list'))
const UpdateAudit = lazy(() => import('./audit-list/update-audit'))
const UpdateSupervision = lazy(() => import('./audit-list/update-supervision'))
const SelfAssessmentList = lazy(
  () => import('./self-Assessment/self-assessment-list')
)
const UpdateSelfAssessment = lazy(
  () => import('./self-Assessment/update-self-assessment')
)
const CreateSelfAssessment = lazy(
  () => import('./self-Assessment/create-self-assessment')
)
const ListPage = lazy(() => import('./reporting/list-pages'))
const Notification = lazy(() => import('./notification'))
const HotelRevisedDetail = lazy(() => import('./hotel/hotel-revised-detail'))
const HotelIktmDetail = lazy(() => import('./hotel/hotel-iktm-detail'))
const HotelCertificateRevisedApplicationDetail = lazy(
  () => import('./hotel/hotel-certificate-revision-application-detail')
)

const HotelRevisedAdminDetail = lazy(
  () => import('./hotel/hotel-revised-admin-detail')
)
const HotelCertificateRevisedAdminDetail = lazy(
  () => import('./hotel/hotel-certificate-revised-admin-detail')
)

const ApplicationHotelList = lazy(
  () => import('./application-hotel/application-hotel-list')
)

const LetterOfConsentList = lazy(() => import('./letter-of-consent-list'))

const FacilityInformationCityDirector = lazy(
  () => import('./hotel/facility-informations-city-directors')
)
const CarbonFacilityListDetail = lazy(
  () => import('./carbon-facility-list/carbon-facility-list-detail')
)
const CarbonEmissionFactor = lazy(() => import('./carbon-emission-factor'))

const CreateCarbonFacility = lazy(
  () => import('./carbon-facility-list/carbon-facility-create-form')
)

const CarbonFootList = lazy(
  () => import('./carbon-footprintlist/carbonfoot-list')
)
const UpdateCarbonFoot = lazy(
  () => import('./carbon-footprintlist/update-carbonfoot')
)
const RevisedCarbon = lazy(
  () => import('./carbon-footprintlist/revised-carbonfoot')
)
const RevisedUpdateCarbon = lazy(
  () => import('./carbon-footprintlist/revised-update-carbonfoot')
)
const CreateCarbonFoot = lazy(
  () => import('./carbon-footprintlist/create-carbonfoot')
)
const RestrauntList = lazy(() => import('./restaurant/restaurant-list'))
const RestaurantUpdateAdmin = lazy(
  () => import('./restaurant/update-restaurant-admin')
)
const RestrauntUpdate = lazy(() => import('./restaurant/restaurant-update'))
const RestrauntCreate = lazy(() => import('./restaurant/create-restaurant'))

const RestaurantCertificateList = lazy(
  () => import('./restaurant-certificate/restaurant-certificate-list')
)
const UpdateRestaurantCertificate = lazy(
  () => import('./restaurant-certificate/update-restaurant-certificate')
)
const CreateRestaurantCertificate = lazy(
  () => import('./restaurant-certificate/create-restaurant-certificate')
)

const RequestApprovalRestaurant = lazy(
  () => import('./request-approval-restaurant')
)

const ApprovalAuditRestaurant = lazy(
  () => import('./approval-audit-restaurant')
)
const AuditListRestaurant = lazy(
  () => import('./audit-list-restaurant/audit-list-restaurant')
)
const UpdateRestaurantAudit = lazy(
  () => import('./audit-list-restaurant/update-audit-restaurant')
)
const SelfAssessmentRestaurantList = lazy(
  () => import('./self-Assessment-restaurant/self-assessment-restaurant-list')
)

const UpdateRestaurantSelfAssessment = lazy(
  () => import('./self-Assessment-restaurant/update-self-assessment-restaurant')
)
const CreateRestaurantSelfAssessment = lazy(
  () => import('./self-Assessment-restaurant/create-self-assessment-restaurant')
)
const RestaurantRevisionList = lazy(() => import('./restaurant-revision'))
const UpdateRestaurantCertificateAdmin = lazy(
  () => import('./restaurant-certificate/update-restaurant-certificate-admin')
)

const RestaurantCertificateRevisionAdminList = lazy(
  () => import('./restaurant-certificate-revision-admin')
)

const RestaurantCertificateRevisedAdminDetail = lazy(
  () => import('./restaurant/restaurant-certificate-revised-admin-detail')
)

const RestaurantCertificateRevisionApplication = lazy(
  () => import('./restaurant-certificate-revision-application')
)

const RestaurantCertificateRevisedApplicationDetail = lazy(
  () =>
    import(
      './restaurant-certificate/restaurant-certificate-revision-application-detail'
    )
)

const ApplicationRestaurantList = lazy(
  () => import('./application-restaurant/application-restaurant-list')
)
const RestaurantRevisionAdminList = lazy(
  () => import('./restaurant-revision-admin')
)

const RestaurantRevisedAdminDetail = lazy(
  () => import('./restaurant/restaurant-revised-admin-detail')
)
const RestaurantRevisedDetail = lazy(
  () => import('./restaurant/restaurant-revised-detail')
)

const UpdateRestaurantRevised = lazy(
  () => import('./restaurant/update-restaurant-revised')
)
const CarbonFootPrintDataList = lazy(() => import('./carbon-data-list'))
const ResultScreen = lazy(() => import('./result-screen'))

const routes: RouteProps[] = [
  {
    component: Home,
    path: '/',
  },
  {
    component: Home,
    path: '/home',
  },
  {
    component: Reporting,
    path: '/reporting',
  },
  {
    component: Dashboard,
    path: '/dashboard',
  },
  {
    component: DashboardDetailUpdate,
    path: '/dashboard-detail',
  },
  {
    component: SignIn,
    path: '/signin',
  },
  {
    component: SignUp,
    path: '/signup',
  },
  {
    component: SignOut,
    path: '/signout',
  },
  {
    component: SignOut,
    path: '/signout/:uid',
  },
  {
    component: ChangeUser,
    path: '/change-user',
  },
  {
    component: FacilityAdminChangeRequest,
    path: '/facility-admin-change-request',
  },
  {
    component: FacilityAdminChangeList,
    path: '/facility-admin-change-list',
  },
  {
    component: FacilityAdminChangeDetail,
    path: '/facility-admin-change/detail/:id',
  },

  {
    component: CreateDictionary,
    path: '/dictionary/create',
  },

  {
    component: UpdateDictionary,
    path: '/dictionary/update/:id',
  },
  {
    component: DictionaryList,
    path: '/dictionary',
  },
  {
    component: CertificationReport,
    path: '/certification-report',
  },
  {
    component: CreateLayoverSubCategory,
    path: '/layover-subcategory/create',
  },
  {
    component: UpdateLayoverSubCategory,
    path: '/layover-subcategory/update/:id',
  },
  {
    component: LayoverSubCategoryList,
    path: '/layover-subcategory',
  },
  {
    component: CreateLayoverFacilityType,
    path: '/layover-facility-type/create',
  },
  {
    component: UpdateLayoverFacilityType,
    path: '/layover-facility-type/update/:id',
  },
  {
    component: LayoverFacilityTypeList,
    path: '/layover-facility-type',
  },
  {
    component: CreateOtherDocument,
    path: '/other-document/create',
  },
  {
    component: UpdateOtherDocument,
    path: '/other-document/update/:id',
  },
  {
    component: OtherDocumentList,
    path: '/other-document',
  },
  {
    component: CreateHotel,
    path: '/hotel/create',
  },
  {
    component: UpdateHotel,
    path: '/hotel/update/:id',
  },
  {
    component: UpdateHotelAdmin,
    path: '/hotel/update-hotel-admin/:id',
  },
  {
    component: UpdateHotelRevised,
    path: '/hotel/update-revised/:id',
  },
  {
    component: HotelList,
    path: '/hotel',
  },
  {
    component: CreateCertificateType,
    path: '/certificate-type/create',
  },
  {
    component: UpdateCertificateType,
    path: '/certificate-type/update/:id',
  },
  {
    component: CertificateTypeList,
    path: '/certificate-type',
  },
  {
    component: ApplicationUserList,
    path: '/application-user',
  },
  {
    component: ApplicationUserDetail,
    path: '/application-user/detail/:id',
  },
  {
    component: UserList,
    path: '/user',
  },
  {
    component: LogList,
    path: '/log',
  },
  {
    component: CreateUser,
    path: '/user/create',
  },
  {
    component: UpdateUser,
    path: '/user/update/:id',
  },

  {
    component: AuditCompanyList,
    path: '/audit-company',
  },
  {
    component: CreateAuditCompany,
    path: '/audit-company/create',
  },
  {
    component: UpdateAuditCompany,
    path: '/audit-company/update/:id',
  },
  {
    component: HotelCertificateList,
    path: '/hotel-certificate',
  },
  {
    component: CreateHotelCertificate,
    path: '/hotel-certificate/create',
  },
  {
    component: UpdateHotelCertificate,
    path: '/hotel-certificate/update/:id',
  },
  {
    component: UpdateHotelCertificateAdmin,
    path: '/hotel-certificate-admin/update/:id',
  },
  {
    component: RolePermissionUpdate,
    path: '/role-permission/update/:id',
  },
  {
    component: RolePermissionList,
    path: '/role-permission',
  },
  {
    component: MailManagementUpdate,
    path: '/mail-management/update/:id',
  },
  {
    component: MailManagementList,
    path: '/mail-management',
  },
  {
    component: Profile,
    path: '/profile',
  },
  {
    component: GstcList,
    path: '/gstc',
  },
  {
    component: GstcDictionaryList,
    path: '/gstc-dictionary-list',
  },
  {
    component: methodologyInformationList,
    path: '/methodology-information-list',
  },
  {
    component: Email,
    path: '/forgot-password',
  },
  {
    component: Password,
    path: '/reset-password/reset',
  },
  {
    component: VerifacitionEmail,
    path: '/mail-verification',
  },
  {
    component: CreateDashboard,
    path: '/dashboard/create',
  },
  {
    component: UpdateDashboard,
    path: '/dashboard/update/:id',
  },
  {
    component: DashboardList,
    path: '/dashboard-list',
  },
  {
    component: RequestApproval,
    path: '/request-approval',
  },
  {
    component: ApprovalAudit,
    path: '/approval-audit',
  },
  {
    component: TransferRequest,
    path: '/transfer-request',
  },
  {
    component: AuditList,
    path: '/audit-list',
  },
  {
    component: UpdateAudit,
    path: '/audit/update/:id',
  },
  {
    component: UpdateSupervision,
    path: '/supervision/update/:id',
  },
  {
    component: SelfAssessmentList,
    path: '/self-assessment',
  },
  {
    component: UpdateSelfAssessment,
    path: '/self-assessment/update/:id',
  },
  {
    component: CreateSelfAssessment,
    path: '/self-assessment/create',
  },
  {
    component: ListPage,
    path: '/list-page',
  },
  {
    component: CategoryInfoManagement,
    path: '/categoryInfo-Management',
  },
  {
    component: ListPage,
    path: '/list-page',
  },
  {
    component: Notification,
    path: '/notification',
  },
  {
    component: ApplicationHotelList,
    path: '/application-hotel',
  },
  {
    component: LetterOfConsentList,
    path: '/letter-of-consent',
  },
  {
    component: FacilityRevisionList,
    path: '/facility-revision',
  },
  {
    component: FacilityCertificateRevisionApplication,
    path: '/facility-certificate-revision-application',
  },
  {
    component: FacilityRevisionAdminList,
    path: '/facility-revision-admin',
  },
  {
    component: FacilityCertificateRevisionAdminList,
    path: '/facility-certificate-revision-admin',
  },
  {
    component: HotelRevisedDetail,
    path: '/facility-revision/detail/:id',
  },
  {
    component: HotelRevisedAdminDetail,
    path: '/facility-revision-admin/detail/:id',
  },
  {
    component: HotelCertificateRevisedAdminDetail,
    path: '/facility-certificate-revision-admin/detail/:id',
  },
  {
    component: HotelCertificateRevisedApplicationDetail,
    path: '/facility-certificate-revision-application/detail/:id',
  },
  {
    component: FacilityInformationCityDirector,
    path: '/facility-informations-city-directors',
  },
  {
    component: HotelIktmDetail,
    path: '/facility-iktm/detail/:id',
  },
  {
    component: CarbonParameter,
    path: '/carbon-parameter',
  },
  {
    component: CarbonParameterUpdate,
    path: '/carbon-parameter/update/:id',
  },

  {
    component: CarbonFacilityList,
    path: '/carbon-facility-list',
  },
  {
    component: CarbonHomePage,
    path: '/carbon-home-page',
  },
  {
    component: CarbonFacilityListDetail,
    path: '/carbon-facility-list/detail/:id&:year&:month',
  },
  {
    component: CreateCarbonFacility,
    path: '/carbon-facility-list/create',
  },
  {
    component: CarbonResult,
    path: '/carbon-result/:id&:year&:month',
  },
  {
    component: CarbonResult,
    path: '/carbon-approval-result/:id&:year&:month',
  },
  {
    component: CarbonPerformanceReport,
    path: '/carbon-performance-report',
  },
  {
    component: CarbonPerformanceReportV2,
    path: '/carbon-performance-report-v2',
  },
  {
    component: CarbonEmissionFactor,
    path: '/carbon-emission-factor',
  },

  {
    component: ApplicationUserDetail,
    path: '/application-user/detail/:id',
  },
  {
    component: CarbonFootList,
    path: '/carbonFoot-list',
  },
  {
    component: UpdateCarbonFoot,
    path: '/carbonFoot/update/:id&:year&:month&:draft',
  },
  {
    component: RevisedCarbon,
    path: '/carbonFoot/revised/:id&:year&:month',
  },
  {
    component: RevisedUpdateCarbon,
    path: '/carbonFoot/revised/update/:id&:year&:month',
  },
  {
    component: CreateCarbonFoot,
    path: '/carbonFoot/create/:hotelId&:year&:month',
  },
  // {
  //   component: CarbonInfoManagement,
  //   path: '/carbonInfo-management',
  // },

  {
    component: RestaurantCertificateList,
    path: '/restaurant-certificate',
  },

  {
    component: UpdateRestaurantCertificate,
    path: '/restaurant-certificate/update/:id',
  },
  {
    component: RestrauntList,
    path: '/restaurant',
  },
  {
    component: RestaurantUpdateAdmin,
    path: '/restaurant/update-restaurant-admin/:id',
  },
  {
    component: RestrauntUpdate,
    path: '/restaurant/update/:id',
  },
  {
    component: RestrauntCreate,
    path: '/restaurant/create',
  },
  {
    component: CreateRestaurantCertificate,
    path: '/restaurant-certificate/create',
  },
  {
    component: RequestApprovalRestaurant,
    path: '/request-approval-restaurant',
  },
  {
    component: ApprovalAuditRestaurant,
    path: '/approval-audit-restaurant',
  },

  {
    component: AuditListRestaurant,
    path: '/audit-list-restaurant',
  },
  {
    component: UpdateRestaurantAudit,
    path: '/audit/update-restaurant/:id',
  },
  {
    component: SelfAssessmentRestaurantList,
    path: '/self-assessment-restaurant',
  },
  {
    component: UpdateRestaurantSelfAssessment,
    path: '/self-assessment-restaurant/update/:id',
  },
  {
    component: CreateRestaurantSelfAssessment,
    path: '/self-assessment-restaurant/create',
  },

  {
    component: RestaurantRevisionList,
    path: '/restaurant-revision',
  },
  {
    component: UpdateRestaurantCertificateAdmin,
    path: '/restaurant-certificate-admin/update/:id',
  },
  {
    component: RestaurantCertificateRevisionAdminList,
    path: '/restaurant-certificate-revision-admin',
  },

  {
    component: RestaurantCertificateRevisedAdminDetail,
    path: '/restaurant-certificate-revision-admin/detail/:id',
  },
  {
    component: RestaurantCertificateRevisionApplication,
    path: '/restaurant-certificate-revision-application',
  },
  {
    component: RestaurantCertificateRevisedApplicationDetail,
    path: '/restaurant-certificate-revision-application/detail/:id',
  },
  {
    component: ApplicationRestaurantList,
    path: '/application-restaurant',
  },
  {
    component: RestaurantRevisionAdminList,
    path: '/restaurant-revision-admin',
  },

  {
    component: RestaurantRevisedAdminDetail,
    path: '/restaurant-revision-admin/detail/:id',
  },
  {
    component: RestaurantRevisedDetail,
    path: '/restaurant-revision/detail/:id',
  },

  {
    component: UpdateRestaurantRevised,
    path: '/restaurant/update-revised/:id',
  },
  {
    component: CarbonFootPrintDataList,
    path: '/carbon-data-list',
  },
  {
    component: ResultScreen,
    path: '/result-screen',
  },
  {
    component: WorkList,
    path: '/work-list',
  },
  {
    component: SendLocation,
    path: '/send-location/:id',
  },
]

export default routes
